import { SET_LOCALE } from "../../actions/controllers/locale";

export function locale(state = { data: null }, action) {
  switch (action.type) {
    case SET_LOCALE:
      return {
        data: action.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/controllers/locale.js